import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Api from 'api';
import PATHS from 'constants/paths';

const ComplaintIndicator = ({ bookingId, isHost }) => {
  const [complaint, setComplaint] = useState(null);

  useEffect(() => {
    if (!bookingId) return undefined;
    let cancelled = false;
    setComplaint(null);
    const fetch = isHost
      ? Api.fetchHostComplaintsByBooking(bookingId)
      : Api.fetchComplaintsByBooking(bookingId);
    fetch
      .then((data) => data.rows || [])
      .then((complaints) => {
        if (!cancelled) {
          setComplaint(complaints.length > 0 ? complaints[0] : null);
        }
      })
      .catch(() => {
        if (!cancelled) setComplaint(null);
      });
    return () => {
      cancelled = true;
    };
  }, [bookingId, isHost]);

  if (!complaint) return null;

  const path = isHost
    ? `${PATHS.hostComplaints.root}/${complaint.id}`
    : `${PATHS.complaints.root}/${complaint.id}`;

  return (
    <Box mt={2}>
      <Alert severity={isHost ? 'warning' : 'info'} elevation={3}>
        <Typography variant="body2">
          {isHost ? (
            <FormattedMessage
              id="bookingForm.complaintFiled.host"
              defaultMessage="A complaint has been filed for this booking."
            />
          ) : (
            <FormattedMessage
              id="bookingForm.complaintFiled.guest"
              defaultMessage="You have filed a complaint for this booking."
            />
          )}
        </Typography>
        <Typography variant="body2">
          <Link to={path}>
            <FormattedMessage
              id="bookingForm.complaintFiled.link"
              defaultMessage="View complaint"
            />
          </Link>
        </Typography>
      </Alert>
    </Box>
  );
};

ComplaintIndicator.propTypes = {
  bookingId: PropTypes.number.isRequired,
  isHost: PropTypes.bool,
};

export default ComplaintIndicator;
